import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import MarketSignpostingIconsImpl from './market-signposting-icons.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Module that displays signposting icons for aggregated market pane.
 *
 * @class MarketSignpostingIcons
 * @memberof Mojito.Modules.AggregatedMarketPane
 */

/**
 * MarketSignpostingIcons prop types.
 *
 * @property {object} [earlyPayout] - Early payout object.
 * @property {boolean} [hasCashout = false] - Set true to show cashout icon.
 * @property {boolean} [hasMatchAcca = false] - Set true to show match acca icon.
 *
 * @memberof Mojito.Modules.AggregatedMarketPane.MarketSignpostingIcons
 */
const propTypes = {
    earlyPayout: PropTypes.object,
    hasCashout: PropTypes.bool,
    hasMatchAcca: PropTypes.bool,
};

const defaultProps = {
    hasCashout: false,
    hasMatchAcca: false,
};

export default UIView(
    'MarketSignpostingIcons',
    MarketSignpostingIconsImpl,
    propTypes,
    defaultProps
);
